import { logAction, useRelodeReducer, useSnackMiddleware } from "@relode/core";
import * as React from "react";

import { useCombinedDashboardFeatureHandlers } from "./combinedDashboardFeatureHandlers";
import { DashboardActions, useDashboardActions } from "./dashboardActions";
import { dashboardReducer } from "./dashboardReducer";
import { DashboardState, initialDashboardState } from "./dashboardState";

type IDashboardContext = {
    state: DashboardState;
    actions: DashboardActions;
};

export const DashboardContext = React.createContext<
    IDashboardContext | undefined
>(undefined);

export const useDashboardContext = () => {
    const context = React.useContext(DashboardContext);
    if (!context) {
        throw new Error(
            "useDashboardContext must be used within an appropriate provider"
        );
    }
    return context;
};

export const DashboardProvider = (props: { children: React.ReactNode }) => {
    const [state, dispatch] = useRelodeReducer(
        dashboardReducer,
        initialDashboardState,
        [useSnackMiddleware(), logAction]
    );
    const actions = useDashboardActions(dispatch);
    useCombinedDashboardFeatureHandlers(state, actions);

    const value = {
        state,
        actions,
    } as IDashboardContext;
    return <DashboardContext.Provider value={value} {...props} />;
};
